import TemplateView from '../../../../../../js/TemplateView'
import messageResource from '../../../../../../js/messageResource'
import {FEEDS_TOOLTIP_EXTRA_CLASS} from '../../../constants'
import tooltip from '../../../../../../js/SimpleSingletonTooltip'

export default class FeedActionsCell extends TemplateView {
    constructor({
        onRegenerateClick,
        onDeleteClick,
    }) {
        super()

        this.callbacks = {
            onRegenerateClick,
            onDeleteClick
        }

        this.state = {
            regenerateActive: false,
            deleteActive: false,
        }

        this.onStatePropertyChanged('regenerateActive', (active) => {
            this.$regenerateButton.toggleClass('active', active)
        })

        this.onStatePropertyChanged('deleteActive', (active) => {
            this.$deleteButton.toggleClass('active', active)
        })
    }

    templateHtml() {
        return `<div class='actionsCell'>
                    <div class='separator'/>
                    <div class='regenerateFeed feedAction'/>
                    <div class='separator'/>
                    <div class='deleteFeed feedAction'/>
                </div>`
    }

    afterRender() {
        this.$regenerateButton = this.find('.regenerateFeed')
        this.$deleteButton = this.find('.deleteFeed')
        this.$regenerateButton.on('click', () => this.callbacks.onRegenerateClick(this.$regenerateButton))
        this.$deleteButton.on('click', () => this.callbacks.onDeleteClick(this.$deleteButton))

        tooltip(this.$regenerateButton, {
            extraClass: FEEDS_TOOLTIP_EXTRA_CLASS,
            text: messageResource.getMessage('icalendar.page.table.button.tooltip.regenerate')
        })

        tooltip(this.$deleteButton, {
            extraClass: FEEDS_TOOLTIP_EXTRA_CLASS,
            text: messageResource.getMessage('icalendar.page.table.button.tooltip.delete')
        })
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/cells/FeedActionsCell.js